module.exports = __webpack_public_path__ + "img/crystal-480-60.4b461ce1.jpg";